<template>
  <!-- <div class="echarts" id="housingRightThree"></div> -->
  <!-- 柱状图 -->
  <div id="housingRightThree" class="echarts"></div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,

  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
import * as echarts from "echarts";
import { carEquimentcount } from "@/api/dataAnalysis/carAnalysis.js";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      echartsNameList: [],
      echartsValueList: [],
      colorList: [
        { name: "1公司", from: "#4CA0FE", to: "#4CA0FE" },
        { name: "2公司", from: "#4CA0FE", to: "#4CA0FE" },
        { name: "3公司", from: "#4CA0FE", to: "#4DFAE0" },
        { name: "4公司", from: "#4CA0FE", to: "#4DFAE0" },
        { name: "5公司", from: "#4CA0FE", to: "#4CA0FE" },
      ],
    });
    const refData = toRefs(data);
    const numberall = async () => {
      const res = await carEquimentcount();
      if (res.code == 0) {
        res.data.forEach((element, index) => {
          if (index < 5) {
            let obj = {
              name: element.name,
              value: element.value,
            };
            data.echartsNameList.push(element.name);
            data.echartsValueList.push(obj);
            data.colorList[index].name = element.name;
          }
        });
      }
    };

    onMounted(async () => {
      await numberall();
      // echarts项目初始化
      const myChart = echarts.init(
        document.getElementById("housingRightThree")
      );
      myChart.setOption({
        tooltip: {
          show: false, // 不显示鼠标移入提示框组件
        },
        legend: {
          show: false, // 不显示图列组件
        },
        grid: {
          // 直角坐标系绘图网格
          top: 15,
          left: 0,
          bottom: 15,
        },
        xAxis: {
          show: false, // 不显示x轴
        },
        yAxis: [
          {
            type: "category",
            inverse: true, // 倒叙，false会从小到大排
            axisLine: {
              show: false, // 不显示坐标轴轴线
            },
            axisTick: {
              show: false, // 不显示刻度线
            },
            offset: -20,
            zlevel: 100,
            position: "left",
            axisLabel: {
              textStyle: {
                color: "#fff",
                align: "left",
              },
            },
            data: data.echartsNameList,
          },
        ],
        series: [
          {
            barCategoryGap: "15%", // 柱间距，若是想要该属性生效，则不能设置barWidth属性
            name: "value",
            type: "bar",
            // 文本标签
            label: {
              show: true,
              color: "#fff",
              formatter: (info) => {
                return info.value;
              },
              position: "right",
            },
            // 柱条样式
            itemStyle: {
              height: 40,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                {
                  offset: 0,
                  color: "#7416F7",
                },
                {
                  offset: 1,
                  color: "#E021FD",
                },
              ]),
              barBorderRadius: 50, // 柱条圆角
            },
            data: data.echartsValueList.map((item) => {
              let itemStyle;
              data.colorList.forEach((color) => {
                if (item.name === color.name) {
                  // 渐变颜色
                  itemStyle = {
                    color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                      {
                        offset: 0,
                        color: color.from,
                      },
                      {
                        offset: 1,
                        color: color.to,
                      },
                    ]),
                    barBorderRadius: 50, // 柱条圆角
                  };
                }
              });
              return {
                name: item.name,
                value: item.value,
                itemStyle,
              };
            }),
          },
        ],
      });

      window.addEventListener("resize", () => {
        myChart.resize();
      });
    });
  },
});
</script>
<style lang="scss" scoped>
#housingRightThree {
  width: 100%;
  height: 90%;
}
</style>
